import axios from "axios";
import AuthService from "@/service/auth_service";
import HttpResponse from "@/service/http_response";
import store from "../store/index";

/**
 * Wrapper to easily execute HTTP requests to the Google functions server.
 */
class Http {
  constructor() {
    this._axios = new axios.create({
      baseURL: "https://us-central1-beyla-1.cloudfunctions.net/",
      responseType: "json"
    });
  }

  /**
   * Executes a HTTP GET request and returns the response
   *
   * @param {*} url URL for the GET request.
   * @param {*} urlParts URL urlParts for the GET request.
   * @param {*} query Query data to include in the URL.
   */
  async get(url, { urlParts, query } = {}) {
    return await this._request("get", url, {
      query: query,
      urlParts: urlParts
    });
  }

  /**
   * Executes a HTTP PUT request and returns the response.
   *
   * @param {str} url URL for the PUT request.
   * @param {*} urlParts URL urlParts for the PUT request.
   * @param {*} body Data to be sent in the request's body.
   * @returns {Promise<HttpResponse>} The HTTP reponse for this request.
   */
  async put(url, { urlParts, body } = {}) {
    return await this._request("put", url, {
      urlParts: urlParts,
      body: body
    });
  }

  /**
   * Executes a HTTP POST request and returns the response.
   *
   * @param {str} url URL for the POST request.
   * @param {*} urlParts URL urlParts for the POST request.
   * @param {*} body Data to be sent in the request's body.
   * @returns {Promise<HttpResponse>} The HTTP reponse for this request.
   */
  async post(url, { urlParts, body } = {}) {
    return await this._request("post", url, {
      urlParts: urlParts,
      body: body
    });
  }

  /**
   * Executes a HTTP DELETE request and returns the response.
   *
   * @param {str} url URL for the DELETE request.
   * @param {*} urlParts URL urlParts for the DELETE request.
   * @returns {Promise<HttpResponse>} The HTTP reponse for this request.
   */
  async delete(url, { urlParts, body } = {}) {
    return this._request("delete", url, { urlParts: urlParts, body: body });
  }

  /**
   * Executes a HTTP POST request to Publish and returns the response.
   *
   * @returns {Promise<HttpResponse>} The HTTP reponse for this request.
   */
  async publishMenu() {
    return await this._request("post", "publish", {
      body: { restaurantId: store.getters.restaurant.id }
    });
  }

  /**
   * Creates a HTTP request to interact with Google functions.
   *
   * @param {string} method HTTP Method to use.
   * @param {string} url URL for the request.
   * @param {*} body Data for the request.
   */
  async _request(method, url, { urlParts, query, body } = {}) {
    let partialUrl = "";
    if (urlParts) {
      partialUrl += "/" + urlParts.join("/");
    }

    let token = await AuthService.info.getToken();
    this._axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    // console.warn(
    //   `[DON'T SHOW THIS IN PRODUCTION]\n[ ${method.toUpperCase()} ]: /${url}${partialUrl}\nparams: ${JSON.stringify(
    //     query
    //   )}\nbody: ${JSON.stringify(body)}`
    // );

    let response = await this._axios.request({
      method: method,
      url: `${url}${partialUrl}`,
      params: query,
      data: body
    });
    delete this._axios.defaults.headers.common["Authorization"];
    return new HttpResponse({ status: response.status, data: response.data });
  }
}

const http = new Http();

export default http;
